export const GET_USER_DETAILS_REQUEST = "get_user_details_request";
export const GET_USER_DETAILS_RESPONSE = "get_user_details_response";

export const UPDATE_USER_STATUS_BY_USER_ID_REQUEST =
  "update_user_status_by_user_id_request";
export const UPDATE_USER_STATUS_BY_USER_ID_RESPONSE =
  "update_user_status_by_user_id_response";
